import { Link, Text } from '@applyboard/crystal-ui'
import { useGetProgram } from '../../../hooks'

export function ReviewRequirementsButton({ programId }: { programId: string }) {
  const { program } = useGetProgram({ id: programId })

  return (
    <Text variant={{ xs: 'titleS', md: 'labelL' }} overflow="nowrap">
      <Link
        href={!!program ? `https://${program.attributes.url}` : '#'}
        mode="override_user_choice_and_open_in_new_tab"
        variant="standalone"
      >
        Review requirements
      </Link>
    </Text>
  )
}
